import {
  IPartnerPreparationReport,
  IWorkOrder,
} from "../../types/workorder.types";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 200);

interface GetWorkOrderParams {
  status?: string[] | string;
  search?: string;
  page?: number;
  itemsPerPage?: number;
  fields?: string;
  mechanic?: string;
  payed?: boolean;
}

export async function getPreparationReportsWorkOrder({
  status = [],
  search = "",
  page = 1,
  itemsPerPage = 10,
  fields = "workOrderCode,licensePlate,budgetWorkorder,pieceQuantity,status,createdAt,type,amount, companyId",
}: GetWorkOrderParams = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);

  const url = `${API_URL}/reports/preparation?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IWorkOrder[]
  >;

  const data = result.data.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  return { ok: result.ok, data, totalItems: result.data.length };
}
export async function getPartnerPreparationReport(companyName: string) {
  if (!companyName) {
    return { ok: false, message: "O nome do parceiro é obrigatório." };
  }

  const url = `${API_URL}/reports/partner-preparation/${encodeURIComponent(
    companyName
  )}`;

  const result = (await makeRequest(
    url
  )) as ApiResponseType<IPartnerPreparationReport>;

  return {
    ok: result.ok,
    data: result.data,
    message: result.message,
  };
}
export async function getWorkOrders({
  status = [],
  search = "",
  page = 1,
  itemsPerPage = 10,
  payed = false,
  mechanic = "",
}: GetWorkOrderParams = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
  });

  if (mechanic) {
    params.append("mechanic", mechanic);
  }
  if (payed) {
    params.append("payed", payed.toString());
  }
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  if (statusParam) params.append("filters[status]", statusParam);
  if (search) params.append("search", search);
  const url = `${API_URL}/workorders?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IWorkOrder[]
  >;
  return {
    ok: result.ok,
    data: result.data,
    page: result.page,
    totalItems: result.totalItems,
  };
}
export async function getWorkOrderById(workOrderId: string) {
  const url = `${API_URL}/workorder/${workOrderId}`;

  return makeRequestDebounced(url) as Promise<ApiResponseType<IWorkOrder>>;
}

export async function markWorkOrdersAsPayed(workOrderIds: string[]) {
  const url = `${API_URL}/workorders/mark-as-payed`;
  const options = {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ workOrderIds }),
  };

  return makeRequest(url, options) as Promise<
    ApiResponseType<{ modifiedCount: number }>
  >;
}
